import WebSocketClient from '../plugins/WebSocketClient';
import {
	NotificationsClient
} from '../clients/NotificationsClient';
import {WEBSOCKET_HOST,WEBSOCKET_PORT} from '../Variables';


export const NotificationsModule = {
	namespaced: true,
	state: {
		queue: [],
		socket: null,
		// host: 'localhost',
		// host: 'api.genexinstitute.com/socket',
        // port: '9000',
        host: WEBSOCKET_HOST,
		port: WEBSOCKET_PORT,
		reconnectInterval: 5000,
		readNotifications: []
	},
	mutations: {
		PUSH_TO_QUEUE(state, payload) {
			state.queue.push(payload)
		},
		SET_QUEUE(state, payload) {
			state.queue = payload
		},
		SET_SOCKET(state, payload) {
			state.socket = payload
		},
		CLEAR_QUEUE(state) {
			state.queue = []
		},
		ADD_TO_READ(state, payload) {
			state.readNotifications.push(payload)
		},
		CLEAR_READ(state) {
			state.readNotifications = []
		},
		REMOVE_FROM_QUEUE(state, payload) {
			state.queue = state.queue.filter(
				notification => notification.id != payload
			)
		}
	},
	actions: {
		sendRead({
			commit,
			dispatch,
			state
		}, payload) {
			console.log('send');
			if (payload) {
				NotificationsClient.markNotificationAsSeen(payload).then(() => {
					console.log(state.readNotifications);

					NotificationsClient.markNotificationAsRead(state.readNotifications).then(() => {
						commit('CLEAR_READ')
						dispatch('getNotifications')

					}).catch((err) => {
						console.log(err);
					})
				})
			} else {
				if (state.readNotifications.length > 0) {
					console.log(state.readNotifications);

					NotificationsClient.markNotificationAsRead(state.readNotifications).then(() => {
						commit('CLEAR_READ')
						dispatch('getNotifications')

					}).catch((err) => {
						console.log(err);
					})
				}
			}
		},
		markAllRead({
			commit,
			dispatch,
		}, payload) {
			payload.forEach(notification => {
				commit('ADD_TO_READ', notification.id)
			});
			dispatch('sendRead')

		},
		markRead({
			commit

		}, payload) {
			commit('ADD_TO_READ', payload)
			commit('REMOVE_FROM_QUEUE', payload)
		},
		getNotifications({
			commit
		}) {
			NotificationsClient.getNotifications().then((response) => {
				commit('SET_QUEUE', response.data.notifications)
			}).catch((err) => {
				console.log(err);
			})
		},
		init({
			state,
			commit,
			dispatch
		}, params) {
			let socket = new WebSocketClient(
				state.port,
				state.host,
				state.reconnectInterval
			).init({
				onOpen: (sock) => {
					if (params.onOpen !== undefined) {
						params.onOpen(sock);
					}
				},

				onClose: (sock) => {
					if (params.onClose !== undefined) {
						params.onClose(sock);
					}
				},

				onMessage: (s, message) => {
					if (params.onMessage !== undefined) {
						// params.onMessage(s, message);
						dispatch('getNotifications')
					}
				}
			});

			socket.start();
			commit('SET_SOCKET', socket)
		},

		registerConnection({
			state,
			commit
		}, params) {
			if (params.socket !== undefined) {
				commit('SET_SOCKET', params.socket)
			}

			let payload = {
				'queue:expects_response': false,
				'queue:key': 'CreatesResource',
				'queue:resourceId': params.resourceId
			};

			state.socket.send(JSON.stringify(payload));
		},

		push({
			commit
		}, message) {
			commit('PUSH_TO_QUEUE', message)
		}
	}
}